/*
 * Device checks, in Access Control: for each of the admin's organisations,
 * what its laptops must show of themselves to reach anything inside it, the
 * system disk encrypted and Windows updated lately (server/pkg/devicepolicy).
 * A laptop that fails one is told which and reaches no remote device until it
 * passes. Wording lives in accessWords.js.
 *
 * ! file components/CheckSettings.js
 */
import React, { useState } from "react";
import { FiCheckSquare } from "react-icons/fi";
import * as W from "./accessWords";

export default function CheckSettings({ orgs, send, busy, reload, toast }) {
  return (
    <div className="panel">
      <div className="panel-title">
        <FiCheckSquare style={{ verticalAlign: "-2px", marginRight: 8 }} />
        {W.CHECKS_TITLE}
      </div>
      <div className="panel-sub">{W.CHECKS_LEAD}</div>
      {orgs.map((org) => (
        <OrgChecks key={org.id} org={org} many={orgs.length > 1} send={send} busy={busy} reload={reload} toast={toast} />
      ))}
    </div>
  );
}

function OrgChecks({ org, many, send, busy, reload, toast }) {
  const saved = org.policy?.checks || {};
  const [disk, setDisk] = useState(!!saved.disk_encrypted);
  const [updates, setUpdates] = useState(saved.updated_within_days > 0);
  const [days, setDays] = useState(saved.updated_within_days || 30);
  const name = org.name || org.id;

  const save = async () => {
    try {
      await send(`/devicepolicy/${encodeURIComponent(org.id)}`, "PUT", {
        checks: { disk_encrypted: disk, updated_within_days: updates ? Number(days) : 0 },
      });
      toast.success(W.checksSaved(name));
      reload();
    } catch (err) {
      toast.error(err.message);
    }
  };

  return (
    <div className="ac-newform" role="group" aria-label={W.checksFor(name)}>
      {many && <div className="ac-row-title">{name}</div>}
      <label className="ac-check">
        <input type="checkbox" checked={disk} onChange={(e) => setDisk(e.target.checked)} />
        <span>{W.CHECK_DISK}</span>
      </label>
      <label className="ac-check">
        <input type="checkbox" checked={updates} onChange={(e) => setUpdates(e.target.checked)} />
        <span>{W.CHECK_UPDATES}</span>
        <input className="ac-input ac-days" type="number" min={1} max={365} value={days} disabled={!updates}
          aria-label={W.CHECK_DAYS} onChange={(e) => setDays(e.target.value)} />
        <span>{W.DAYS}</span>
      </label>
      <div>
        <button type="button" className="ac-btn primary" onClick={save} disabled={busy}>{W.SAVE}</button>
      </div>
      <div className="ac-blurb">{W.CHECKS_NOTE}</div>
    </div>
  );
}
